// TODO remove after implementing Stripe v3
(() => {
	// angular
	// 	.module('main')
	// 	.controller('ReactivateCardController', ReactivateCardController);

	ReactivateCardController.$inject = [
		'$rootScope',
		'$scope',
		'$http',
		'$window',
		'stripeDataService',
		'messageService'
	];

	function ReactivateCardController(
		$rootScope,
		$scope,
		$http,
		$window,
		stripeDataService,
		messageService
	) {
		$scope.$on('$viewContentLoaded', () => {
			delete $rootScope.menu_path;
			delete $rootScope.removeBg;
		});

		$scope.sendUpdatedCardDet = function() {
			$scope.buttonDisable = true;

			if (isCardDetailsValid()) {
				stripeDataService
					.getStripeUserKey()
					.subscribe(
						data => sendCardToken(data),
						result => errorStripeCallback(result.data)
					);
			}
		};

		function isCardDetailsValid() {
			const { number, exp_month, exp_year, cvc } = $scope.card;

			const isCardNumberValid = Stripe.card.validateCardNumber(number);
			const isCardCvcValid = Stripe.card.validateCVC(cvc);
			const isCardExpireDateValid = Stripe.card.validateExpiry(
				exp_month,
				exp_year
			);

			if (!isCardNumberValid) {
				messageService.showToaster('e_0', 'subscription');
				$scope.buttonDisable = false;
				return false;
			}

			if (!isCardCvcValid) {
				messageService.showToaster('e_1', 'subscription');
				$scope.buttonDisable = false;
				return false;
			}

			if (!isCardExpireDateValid) {
				messageService.showToaster('e_2', 'subscription');
				$scope.buttonDisable = false;
				return false;
			}

			return true;
		}

		function sendCardToken(data) {
			if (data && data.message) {
				$rootScope.stripePK = data.message;
				Stripe.setPublishableKey($rootScope.stripePK);
				Stripe.card.createToken($scope.card, stripeResponseHandler);
			} else {
				errorStripeCallback(data);
			}
		}

		function errorStripeCallback(result) {
			if (result.errorMessage) {
				toastr.error(result.errorMessage);
			} else {
				messageService.showToaster('e_0', 'general');
			}
			$scope.buttonDisable = false;
		}

		function stripeResponseHandler(status, response) {
			if (response.error) {
				$scope.buttonDisable = false;
				toastr.error(response.error.message);
			} else {
				$scope.stripe_token = response.id;
				$scope.buttonDisable = true;
				stripeTokenServerCall();
			}

			if (!$scope.$$phase) {
				$scope.$apply();
			}
		}

		function stripeTokenServerCall() {
			stripeDataService
				.updateStripe($scope.stripe_token)
				.subscribe(
					() => successServerCall(),
					result => errorStripeCallback(result.data)
				);
		}

		function successServerCall() {
			$scope.buttonDisable = false;
			toastr.success('Credit card details have been updated');
			$window.location.href = '/';
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/reactivateCardController.js